import React from 'react';

import { getColorByDeviceKey } from './RaceColors.js';

import { DataGrid } from '@mui/x-data-grid';
import Checkbox from '@mui/material/Checkbox';

import { convertDateToString } from '../../common/ConvertTools';

import gridSxStyle from "../../common/GridSxStyles.js";

const RaceGrid = React.memo(({ raceDevices, selectedCombinations, handleDeviceSelectionChange, isDesktop }) => {

    // console.log("RaceGrid", JSON.stringify(raceDevices));

    // console.log("RaceGrid / refresh");

    const dataConfig = {
        datasets: [
        ],
    };

    const columns = [
        {
            field: 'select',
            headerName: '',
            width: 50,
            resizable: false,
            renderCell: (params) => {

                if ((params.row.last_timestamp === null) || (params.row.last_timestamp === 0)) {
                    return (<></>)
                } else {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <Checkbox
                                size="small"
                                style={{ width: "20px", padding: 0 }}
                                checked={selectedCombinations.some(item =>
                                    item.id === params.row.id && item.mac_custom.toLowerCase() === params.row.mac_custom.toLowerCase())}
                                onChange={(event) => {
                                    console.log("RaceGrid / renderCell / handleDeviceSelectionChange  / row", params.row.mac_custom);
                                    handleDeviceSelectionChange(params.row, event.target.checked)
                                }}
                            />
                        </div>)
                }
            }
        },
        {
            field: 'first_timestamp',
            headerName: '',
            width: 0,
            // width: 7,
            renderCell: (params) => {
                let colorStyle = {};
                let baseClass = 'fa fa-circle';
                let tooltipMessage = ""


                if (params.row.last_timestamp && (Date.now() - params.row.last_timestamp < 60000)) {
                    colorStyle.color = getColorByDeviceKey(params.row.mac_custom);
                    tooltipMessage = "Active / last seen : " + convertDateToString(params.row.last_timestamp / 1000);
                } else if ((params.row.last_timestamp === null) || (params.row.last_timestamp === 0)) {
                    baseClass = 'fa-solid fa-circle-xmark';
                    colorStyle.color = 'var(--color-grey)';
                    tooltipMessage = "Never seen"
                } else {
                    colorStyle.color = 'var(--color-grey)';
                    tooltipMessage = "Inactive / last seen : " + convertDateToString(params.row.last_timestamp / 1000);
                }

                return (
                    <div style={{ textAlign: 'center' }}>
                        <i className={baseClass} style={{ ...colorStyle, padding: "5px" }} title={tooltipMessage}></i>
                    </div>
                );
            },
        },
        {
            field: 'ble_name',
            headerName: 'Smart Name',
            flex: 1,
        },
        {
            field: 'user_id',
            headerName: 'User',
            flex: 1,
            renderCell: (params) => (
                <div style={{ textAlign: 'center' }}>
                    {params.row.race_username != null ? params.row.race_username : params.row.user_id.split("@")[0]}
                </div>
            ),
        },
    ];

    return (
        <div style={isDesktop ? { height: '100%' } : { height: 400 }} >
            <DataGrid
                // autoHeight
                disableVirtualization
                disableRowSelectionOnClick
                columnHeaderHeight={35}
                rowHeight={30}
                rows={raceDevices}

                columns={columns.map((column) => ({ ...column }))}
                initialState={{
                    ...dataConfig.initialState,
                    sorting: { sortModel: [{ field: 'first_timestamp', sort: 'desc' }], },
                    pagination: { paginationModel: { pageSize: isDesktop ? 14 : 10 } },
                }}
                pageSizeOptions={[isDesktop ? 14 : 10, 20, 25]}
                sx={gridSxStyle}
            />
        </div >
    )
});

export default RaceGrid;
